import HeaderWrapper from '@/components/common/Header/HeaderWrapper';
import TrainerCard, { TrainerCardSkeleton } from '@/components/common/Trainer/TrainerCard';
import { Button } from '@/components/ui/button';
import { GET_ALL_TRAINERS } from '@/Graphql/queries';
import { useQuery } from '@apollo/client';
import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const LIMIT = 24;

const TrainerList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data, loading, fetchMore } = useQuery(GET_ALL_TRAINERS, {
    variables: { limit: LIMIT, offset: 0, filter: { status: true, isTestUser: false } },
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  });

  const loadMore = () => {
    fetchMore({
      variables: { offset: data?.getAllTrainers.length || 0, limit: LIMIT },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult?.getAllTrainers) return previousResult;
        return {
          ...previousResult,
          getAllTrainers: [...previousResult.getAllTrainers, ...fetchMoreResult.getAllTrainers],
        };
      },
    });
  };

  const handleGoBack = () => {
    if (location.key === 'default') {
      navigate('/');
    } else {
      navigate(-1);
    }
  };

  return (
    <div className='w-full  flex flex-col overflow-auto'>
      <HeaderWrapper className='fixed w-full top-0 z-50 flex-col md:flex-row gap-2'>
        <div className='flex w-full items-center gap-2'>
          <Button
            onClick={handleGoBack}
            id='session-details-back-btn'
            variant='ghost'
            size='icon'
            className='text-white'
          >
            <ArrowLeft className='h-5 w-5' />
          </Button>
          <h1 className='text-lg font-semibold'>Meet our Trainers</h1>
        </div>
      </HeaderWrapper>
      <div className='mx-auto w-[1060px] max-w-[98%] h-full mt-28 mb-16'>
        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4'>
          {loading &&
            !data?.getAllTrainers &&
            Array.from({ length: 24 }).map((_, i) => <TrainerCardSkeleton key={i} />)}
          {data?.getAllTrainers?.map((trainer, i) =>
            trainer ? <TrainerCard key={i} trainer={trainer} /> : null,
          )}
          {loading &&
            data?.getAllTrainers &&
            Array.from({ length: 6 }).map((_, i) => <TrainerCardSkeleton key={`load-more-${i}`} />)}
          {!loading && !data?.getAllTrainers.length && <h4>No Trainers Found</h4>}
        </div>
        {data?.getAllTrainersCount &&
        data?.getAllTrainersCount > 10 &&
        data.getAllTrainers.length < data?.getAllTrainersCount ? (
          <div className='w-full p-5 text-center'>
            <Button id='loadmore-sessions' onClick={loadMore} loading={loading}>
              Load More
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default TrainerList;
